class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    /* custom sorting */
    var self = this;
    var filterSortOptions = document.querySelectorAll(".select.sort .sort-options li");
    if(filterSortOptions != null){
      for (let i = 0; i < filterSortOptions.length; i++) {
        filterSortOptions[i].addEventListener("click", function(e){ 
          let sortLabel  = document.querySelector(".current-sort .sort-name");
          sortLabel.innerHTML = this.innerHTML;
          var selectedSort = this.getAttribute("data-value");   
          if(document.querySelector(".select.sort .sort-by-hidden-options select") != null){
            document.querySelector('.select.sort .sort-by-hidden-options select').value = selectedSort;
            self.onSubmitHandler(e);
            for (let j = 0; j < filterSortOptions.length; j++) {
              filterSortOptions[j].classList.remove("selected");
            }
            this.classList.add("selected");
            } 
        });
        filterSortOptions[i].addEventListener("keydown", function(e){ 
          var keycode = (event.keyCode ? event.keyCode : event.which);
          if(keycode == '13'){
            let sortLabel  = document.querySelector(".current-sort .sort-name");
            sortLabel.innerHTML = this.innerHTML;
            var selectedSort = this.getAttribute("data-value");   
            if(document.querySelector(".select.sort .sort-by-hidden-options select") != null){
              document.querySelector('.select.sort .sort-by-hidden-options select').value = selectedSort;
              self.onSubmitHandler(e);
              for (let j = 0; j < filterSortOptions.length; j++) {
                filterSortOptions[j].classList.remove("selected");
              }
              this.classList.add("selected");
              }  
            }
        }); 
      } 
      changeActiveSort();
      setCollectionLayout();
      addMarketingBanners();
    }
    /* custom sorting */

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting' , '.button_facets__count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    var currentURL = window.location.href;
    console.log('test')
    if(currentURL.indexOf("search") > -1 && currentURL.indexOf("type=product") > -1){
      history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}` + "&type=product");
    if (currentURL.indexOf("product") > -1){
      waitForElement('.template-search__results.collection:not(.loading)',function() {
          $('.custom-filter-wrapper .list-menu input').removeAttr('checked');
          setTimeout(function (){
            $('.custom-filter-wrapper .list-menu input[value="product"]').attr('checked', '');
            $('.template-search__results.collection .grid-product.grid-banner').hide();
          },150);
      });
    }
    }else{
      if (currentURL.indexOf("layout=4") > -1) {
        history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}` + "&layout=4");
        waitForElement('.collection .product-grid-container .collection:not(.loading)',function() {
          console.log('test')
          $(".collection .product-grid-container .collection-grid__items").removeClass('grid--3-col-desktop');
          $('.layout-options .layout-opt').removeClass('selected');
          $(".collection .product-grid-container .collection-grid__items").addClass('grid--4-col-desktop');
          $('.layout-options .layout-opt.layout-four').addClass('selected');
        });
      } 
      else{
        history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
      }
    }
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }  

}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
    setCollectionLayout();
    addMarketingBanners();
  }
}

customElements.define('facet-remove', FacetRemove);


/* collection layout */
function setCollectionLayout(){
  var layoutOptions = document.querySelectorAll('.layout-options .layout-opt');
  if(layoutOptions != null){	
    for (let i = 0; i < layoutOptions.length; i++) {	
      layoutOptions[i].addEventListener("click", function(e){ 
        var layoutItems = this.closest(".layout-wrapper").querySelectorAll(".layout-opt"); 	
        for (let j = 0; j <  layoutItems.length; j++) {	
          layoutItems[j].classList.remove("selected");
        }
        this.classList.add("selected");
        /*
        // Update layout of Desktop on Click
        if(this.classList.contains("layout-four")){
          var verticalFilters = document.querySelector(".vertical-facets");
          verticalFilters.classList.add("show-filter-drawer")
        }
        if(this.classList.contains("layout-three")){
          var verticalFilters = document.querySelector(".vertical-facets");
          if(verticalFilters.classList.contains("show-filter-drawer")){
            verticalFilters.classList.remove("show-filter-drawer");
          }
        }*/
        var DataValue = this.getAttribute("data-value");
        var productGrid = document.getElementById("product-grid");
        /*
        // Update layout of Desktop on Click
        if(this.closest(".layout-desktop")){
          if (productGrid.classList.contains("grid--2-col-desktop") || productGrid.classList.contains("grid--3-col-desktop") || productGrid.classList.contains("grid--4-col-desktop") ) {
            productGrid.classList.remove("grid--2-col-desktop");
            productGrid.classList.remove("grid--3-col-desktop");
            productGrid.classList.remove("grid--4-col-desktop");
            productGrid.classList.add(DataValue);
          }
        }*/
          if(this.closest(".layout-mob")){
          if (productGrid.classList.contains("grid--2-col-tablet-down") || productGrid.classList.contains("grid--1-col-tablet-down") ) {
            productGrid.classList.remove("grid--2-col-tablet-down");
            productGrid.classList.remove("grid--1-col-tablet-down");
            productGrid.classList.add(DataValue);
            }
          }
          
      }); 
    }	
  }
}
setCollectionLayout()	
/* collection layout */

/* Active sort options */
function changeActiveSort(){
  let pageUrl = String(window.location.href);
  let sortLabel  = document.querySelector(".current-sort .sort-name");

    if(pageUrl.includes("manual")){
      removeSelected();
      var sortManually= document.querySelector(".sort-options li[data-value='manual']");
      if (sortManually != null){
        sortManually.classList.add("selected");
        sortLabel.innerHTML = sortManually.innerHTML;
      }
    }
    else if(pageUrl.includes("price-ascending")){
      removeSelected();
      var sortAscending= document.querySelector(".sort-options li[data-value='price-ascending']");
      sortAscending.classList.add("selected");
      sortLabel.innerHTML = sortAscending.innerHTML;
    }
    else if(pageUrl.includes("price-descending")){
      removeSelected();
      var sortDescending= document.querySelector(".sort-options li[data-value='price-descending']");
      sortDescending.classList.add("selected");
      sortLabel.innerHTML = sortDescending.innerHTML;
    }
    else{}  

    function removeSelected(){
      var filterSortOptions = document.querySelectorAll(".select.sort .sort-options li");
      for (let j = 0; j < filterSortOptions.length; j++) {
        filterSortOptions[j].classList.remove("selected");
      }
    }
  }
changeActiveSort();
/* Active sort options */

/* marketing banners */
function addMarketingBanners(){
  var gridBlockAll = $('.collection-grid-content .grid-item-block').clone(true);
  var gridCount = 0;
  //Removing blocks
  gridBlockAll.each(function(i){
    var blockID = gridBlockAll[i].id;
    if(gridBlockAll[i] && $(".collection-grid__items").find('#'+blockID).length > 0){
      $(".collection-grid__items").find('#'+blockID).remove();
    }
  });
  //Adding blocks
  gridBlockAll.each(function(i){
    var blockIDold = gridBlockAll[i].id;
    var blockIDnew = 'block-link-' + blockIDold + '-' + i;
    if(gridBlockAll[i]){
      $(gridBlockAll[i]).find('.block-link').attr('id',blockIDnew);
      var position = parseInt($(this).attr('data-order'));
      if(position == 1){
        if($(".collection-grid__items .grid-item__index__"+position).length == 0){
          $(".collection-grid__items .grid__item:last-child").before(gridBlockAll[i]);
        }else{
          $(".collection-grid__items .grid-item__index__"+position).before(gridBlockAll[i]);
        }
      }else{
        $(gridBlockAll[i]).find('.block-link').attr('id',blockIDnew);
        if(position > 1){
          position = position - 1;
        }
        if($(".collection-grid__items .grid-item__index__"+position).length == 0){
          $(".collection-grid__items .grid__item:last-child").after(gridBlockAll[i]);
        }else{
          $(".collection-grid__items .grid-item__index__"+position).after(gridBlockAll[i]);
        }
        // Hide block when block position is greater than products  
        var grid_items = $('.collection-grid__items .grid__item:not(.grid-banner)').length;
        block_position = position + 1;
        if(block_position > grid_items){
          $('.collection-grid__items .grid-product.grid-banner[data-order='+block_position+']').hide();
        }
      }
      equalHeightBlock();
      function equalHeightBlock(){
        var gridHeight = $('.collection-grid__items .grid__item:not(.grid-banner)').height();
        $('.collection-grid__items .grid__item.grid-banner')
            .css('height', gridHeight);
      }
      $(window).on( "resize", function() {
        equalHeightBlock();
      });
      gridCount++;
    }
  });
}
/* marketing banners */
function updateLayout(){
  if (window.location.href.indexOf("layout=4") > -1) {
    console.log('Found')
  }
  else{
    console.log('Not - Found')
    if (window.location.href.indexOf("?") > -1) {
      window.location.href = window.location.href + "&layout=4";
    }
    else{
      window.location.href = window.location.href + "?layout=4";
    }
  }
}
  $(document).on("click",".layout-opt.layout-four",function() {
    updateLayout();
  });

  $(document).on("click",".layout-opt.layout-three",function() {
    var newUrl = window.location.href.replace('layout=4', '');
    window.location.href = newUrl;
  });